import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PieChartWithLegend from '../../../../shared/components/chart/pie-chart-with-legend/PieChartWithLegend';
import { PieChartData } from '../../../../shared/models/common/PieChartData';
import { GroupStats } from '../../../../shared/models/agency-stats/AgencyStatsResponse';
import { OTHERS_COLOR } from '../../../../shared/utils/utils';

const FALLBACK_COLOR = '#6366f1';

interface AgencyStatsPieChartProps {
  groups: GroupStats[];
}

const AgencyStatsPieChart: React.FC<AgencyStatsPieChartProps> = ({ groups }) => {
  const { t } = useTranslation();

  const visibleGroups = useMemo(
    () => groups.filter((g) => g.projectCount > 0),
    [groups]
  );

  const pieData = useMemo<PieChartData[]>(() => {
    const total = visibleGroups.reduce((sum, g) => sum + g.projectCount, 0);
    if (total === 0) return [];
    return visibleGroups.map((g) => ({
      name: g.groupId === null ? t('ungrouped') : g.groupName,
      value: Math.round((g.projectCount / total) * 100),
    }));
  }, [visibleGroups, t]);

  const colorPalette = useMemo(
    () =>
      visibleGroups.map((g) =>
        g.groupId === null ? OTHERS_COLOR : g.groupColor ?? FALLBACK_COLOR
      ),
    [visibleGroups]
  );

  return (
    <div className="stats__panel">
      <div className="page-box__title-action">
        <div className="page-box__title page-box__title--flex">
          {t('agencyStatsProjectDistribution')}
        </div>
      </div>
      <div className="stats-box stats-box--pie-chart">
        <div className="stats-box__content">
          <PieChartWithLegend chartData={pieData} colorPalette={colorPalette} size="SM" />
        </div>
      </div>
    </div>
  );
};

export default AgencyStatsPieChart;
